<template>
	<v-row
		no-gutters
		style="width: 850px"
		class="pt-16 mt-4 mx-auto"
		align="center"
	>
		<v-col cols="6" class="pr-sm-16">
			<div style="width: 345px; position: relative">
				<div
					style="width: 100%; height: 100%; position: absolute; z-index: 2"
				></div>
				<swiper
					class="swiper"
					:options="swiperOption"
					style="border-radius: 20px; overflow: hidden"
				>
					<swiper-slide>
						<div class="slide library"></div>
						<!-- <v-img src="@/assets/images/library-bg.png" class="img"> </v-img> -->
					</swiper-slide>
					<swiper-slide
						><div class="slide bus"></div>
						<!-- <v-img src="@/assets/images/bus-bg.png" class="img"> </v-img> -->
					</swiper-slide>
					<swiper-slide
						><div class="slide home"></div>
						<!-- <v-img src="@/assets/images/home-bg.png" class="img"> </v-img> -->
					</swiper-slide>
				</swiper>
				<div class="hand-wrap">
					<v-img
						:lazy-src="require(`@/assets/images/mockup-hand-${language}.png`)"
						:src="require(`@/assets/images/mockup-hand-${language}@2x.png`)"
					></v-img>
					<!-- <v-img src="@/assets/images/mockup-hand.png"></v-img> -->
				</div>
			</div>

			<!-- <div class="slide">
				<div class="background">
					<div class="img-wrap">
						<img src="@/assets/images/library-bg.png" class="background-img" />
					</div>
					<div class="img-wrap">
						<img src="@/assets/images/bus-bg.png" class="background-img" />
					</div>
					<div class="img-wrap">
						<img src="@/assets/images/home-bg.png" class="background-img" />
					</div>
				</div>
				<v-img
					max-width="297"
					class="hand"
					src="@/assets/images/mockup-hand.png"
				></v-img>
			</div> -->
		</v-col>
		<v-col cols="6" class="pl-sm-11 text-left">
			<h2 class="mb-3 sub--title primary--text">
				{{ $t('anywhere.sub-title') }}
			</h2>
			<h1 class="mb-10 main--title font-weight-bold white-space-pre">
				{{ $t('anywhere.title') }}
			</h1>
			<div>
				<div class="point d-flex align-center mb-3">
					<img src="@/assets/images/library-icon.png" alt="" class="mr-4" />{{
						$t('anywhere.sub-title.library')
					}}
				</div>
				<div class="point d-flex align-center mb-3">
					<img src="@/assets/images/subway-icon.png" alt="" class="mr-4" />{{
						$t('anywhere.sub-title.subway')
					}}
				</div>
				<div class="point d-flex align-center mb-3">
					<img src="@/assets/images/home-icon.png" alt="" class="mr-4" />{{
						$t('anywhere.sub-title.home')
					}}
				</div>
			</div>
		</v-col>
	</v-row>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
	components: {
		swiper,
		swiperSlide,
	},
	data() {
		return {
			swiperOption: {
				autoplay: {
					delay: 1500,
					disableOnInteraction: false,
				},
				// slidesPerView: 1.2,
				// centeredSlides: true,
				// spaceBetween: 15,
				loop: true,
			},
		}
	},
	computed: {
		language() {
			return this.$store.getters['language']
		},
	},
}
</script>

<style lang="scss" scoped>
.slide {
	width: 344px;
	height: 623px;
	background-size: cover;
}
.slide.bus {
	background-image: url('~@/assets/images/bus-bg.png');
}
.slide.home {
	background-image: url('~@/assets/images/home-bg.png');
}
.slide.library {
	background-image: url('~@/assets/images/library-bg.png');
}

.img {
	border-radius: 20px;
}
.hand-wrap {
	position: absolute;
	width: 300px;
	height: 435px;
	bottom: 0;
	right: -3.5px;
	z-index: 2;
	border-radius: 20px;
	overflow: hidden;
}
.hand {
	position: absolute;
	right: -3.5px;
	bottom: -5.3px;
	z-index: 2;
}
.background {
	overflow: hidden;
	animation: slide 5s infinite;
	width: 1035px;
	display: flex;

	border-radius: 20px;
}
.img-wrap {
	width: 345px;
}
.background-img {
	width: 345px;
	z-index: 1;
	margin: 0 5px;
}

.point {
	padding: 8px 12.8px 8px 16px;
	border-radius: 10px;
	background-color: #f4f4f4;
	font-size: 16px;
	font-weight: 500;
	letter-spacing: -0.8px;
	color: #1a1a1a;
	margin-bottom: 15px;
}
@keyframes slide {
	0% {
		margin-left: 0;
	} /* 0 ~ 10  : 정지 */
	10% {
		margin-left: 0;
	} /* 10 ~ 25 : 변이 */
	45% {
		margin-left: -345px;
	} /* 25 ~ 35 : 정지 */
	55% {
		margin-left: -345px;
	} /* 35 ~ 50 : 변이 */
	90% {
		margin-left: -690px;
	}
	100% {
		margin-left: -690px;
	}
}
</style>
